<template>
  <div class="mobilePublicNavigation">
    <div class="logo">
      <img src="@/assets/mobile/mobile-log.png" alt="" @click="jumpHome()" />
    </div>
    <div class="menus">
      <div class="lang" @click="changeLang">
        <img
          v-if="langShow"
          src="@/assets/mobile/home/langImg-active.png"
          alt=""
        />
        <img v-else src="@/assets/mobile/home/langImg-default.png" alt="" />
        <langDropDown v-if="langShow"></langDropDown>
      </div>
      <div class="routerMenu" @click="changeRouterMenu">
        <img
          v-if="routerMenuShow"
          src="@/assets/mobile/home/routerMenu-active.png"
          alt=""
        />
        <img v-else src="@/assets/mobile/home/routerMenu-default.png" alt="" />
      </div>
    </div>
    <routerMenuList v-if="routerMenuShow"></routerMenuList>
  </div>
</template>

<script>
import langDropDown from './langDropDown.vue'
import routerMenuList from './routerMenuList.vue'
export default {
  components: { langDropDown, routerMenuList },
  data () {
    return {
      langShow: false,
      routerMenuShow: false
    }
  },
  methods: {
    changeLang () {
      this.langShow = !this.langShow
      this.routerMenuShow = false
    },
    changeRouterMenu () {
      this.routerMenuShow = !this.routerMenuShow
      this.langShow = false
    },
    jumpHome () {
      if (this.$route.name !== 'home') {
        this.$router.push('/home')
      }
    }
  }
}
</script>

<style scoped lang="less">
.mobilePublicNavigation {
  background-color: #fff;
  position: fixed;
  width: 100%;
  height: 1.28rem;
  padding: 0.27rem 0.43rem;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 9999;
  .logo {
    img {
      height: 0.43rem;
    }
  }
  .menus {
    display: flex;
    align-items: center;
    .lang {
      position: relative;
      img {
        width: 0.53rem;
        height: 0.53rem;
      }
    }
  }
  .routerMenu {
    margin-left: 0.32rem;
    img {
      width: 0.64rem;
      height: 0.64rem;
    }
  }
}
</style>
